export const DataMutationLoginAsyncProvider_QueryKey = {
  loginAsync: (): string => {
    const queryKey = "data-mutation-login-async";
    return queryKey;
  },
};
